/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { icons } from '../../assets/icons';
import flowerLogo from '../../assets/images/flowersLogo.svg';
import fbLogo from '../../assets/images/fbLogo.svg';
import berriesLogo from '../../assets/images/berriesLogo.svg';

const useStyles = makeStyles((theme) => ({
   header: {
     display: 'flex',
     justifyContent: 'space-between',
     alignItems: 'center',
     backgroundColor: theme.palette.common.white,
     padding: '14px 21px 13px 18px',
     '& a': {
      height: '40px'
     }
   },
   closeButton: {
      height: '30px',
      width: '30px',
      border: 'none',
      backgroundColor: 'transparent',
      padding: '0px',
   },
 }));

const RecipientHeader = ({ handleCloseModal, cardIsleParams, ...props }) => {
  const classes = useStyles();

  const generateBrandLogoSrc = () => {
    if (props.brandId === '18F') {
      return flowerLogo;
    } else if (props.brandId === 'FBQ' || props.brandId === 'FB') {
      return fbLogo;
    } else if (props.brandId === 'BRY') {
      return berriesLogo;
    } else {
      return '';
    }
  };



  return (
   <div className={classes.header}>
      <Link to={cardIsleParams ? '/' : '/account/thankyoucards'}>
         <img onClick={handleCloseModal} src={generateBrandLogoSrc()} alt='image of company logo'/>
      </Link>
      <button className={classes.closeButton}  onClick={handleCloseModal} aria-label='close' tabIndex={-1}>
         <Link to={cardIsleParams ? '/' : '/account/thankyoucards'}>{icons.closeIcon}</Link>
      </button>
   </div>
  )
}

export default RecipientHeader